// Data definitions and full verbatim content from Gen 8 Job Descriptions

export const APPLICATION_FORM_URL = "https://forms.gle/Ch6UTpEVf9UkviGh9";

export interface AdvantageCategory {
  title: string;
  items: string[];
}

export interface EvaluationGroup {
  title: string;
  items: string[];
}

export interface DepartmentDetails {
  overview: string[];
  targetAudience: {
    lead?: string;
    items: string[];
  };
  responsibilities: {
    lead?: string;
    items: string[];
  };
  requirements: {
    lead?: string;
    items: string[];
    advantages?: {
      lead?: string;
      items?: string[];
      categories?: AdvantageCategory[];
    };
  };
  evaluation: {
    lead?: string;
    groups: EvaluationGroup[];
  };
  benefits: {
    lead?: string;
    items: string[];
  };
  closingNote?: string;
}

export interface Department {
  id: string;
  name: string;
  title: string;
  badge: string;
  docId: string;
  jdUrl: string;
  previewUrl: string;
  description: string;
  focusItems: string[];
  details: DepartmentDetails;
}

export const DEPARTMENTS: Department[] = [
  {
    id: "ai",
    name: "AI Department",
    title: "Technical AI Engineer",
    badge: "RESEARCH & CORE AI",
    docId: "1MLIomr8dAUXCTyTKI110yGV8OClw8gY-sT_vw2SlnYA",
    jdUrl:
      "https://docs.google.com/document/d/1MLIomr8dAUXCTyTKI110yGV8OClw8gY-sT_vw2SlnYA/edit?usp=drive_link",
    previewUrl:
      "https://docs.google.com/document/d/1MLIomr8dAUXCTyTKI110yGV8OClw8gY-sT_vw2SlnYA/preview",
    description:
      "Chịu trách nhiệm nghiên cứu, xây dựng và triển khai các giải pháp Trí tuệ nhân tạo, Large Language Models (LLM) và Agentic AI có tính thực tiễn phục vụ hoạt động của câu lạc bộ.",
    focusItems: [
      "Agentic AI workflows & Tool calling",
      "RAG pipeline, Vector DB & Embeddings",
      "Prompt engineering & Structured outputs",
      "Tối ưu hóa và kiểm thử ứng dụng AI thực tế",
    ],
    details: {
      overview: [
        "Phòng AI là bộ phận chuyên môn trực thuộc Technical Team của câu lạc bộ GDG On Campus – DUT. Phòng chịu trách nhiệm nghiên cứu, xây dựng và triển khai các giải pháp, ứng dụng Trí tuệ nhân tạo, Large Language Models và Agentic AI có tính thực tiễn phục vụ hoạt động của câu lạc bộ.",
        "Thành viên mới ở vị trí Technical AI Engineer sẽ được định hướng phát triển theo lộ trình từ AI Learner, AI Builder cho đến AI Engineer, từng bước tìm hiểu toàn bộ quy trình xây dựng sản phẩm AI thực tế, từ thiết kế prompt và structured output, xây dựng RAG pipeline, tích hợp API & tools đến đánh giá, kiểm thử và tối ưu hóa ứng dụng.",
      ],
      targetAudience: {
        lead: "Chúng tôi tìm kiếm những ứng viên phù hợp với các tiêu chí sau:",
        items: [
          "Sinh viên của các trường trên địa bàn Thành phố Đà Nẵng.",
          "Ứng viên có mong muốn tìm kiếm môi trường thực hành để xây dựng và hoàn thiện dự án AI/LLM.",
          "Ứng viên tìm hiểu và phát triển về Artificial Intelligence, Large Language Models và Agentic AI.",
          "Sinh viên có đam mê lĩnh vực công nghệ.",
        ],
      },
      responsibilities: {
        lead: "Ở vị trí AI Engineer, bạn sẽ không chỉ học cách sử dụng AI mà còn trực tiếp tham gia:",
        items: [
          "Xây dựng AI applications.",
          "Thiết kế Agent workflow.",
          "Tích hợp LLM với API và external tools.",
          "Xây dựng RAG pipeline.",
          "Làm việc với embeddings và vector database.",
          "Thiết kế prompt và structured output.",
          "Làm việc cùng các thành viên Frontend, Backend và các Technical member khác để xây dựng sản phẩm hoàn chỉnh.",
          "Nghiên cứu và ứng dụng các công nghệ Generative AI, LLM và AI Agent.",
          "Xây dựng các tính năng AI phục vụ các sản phẩm và dự án của GDG On Campus – DUT.",
        ],
      },
      requirements: {
        lead: "Không bắt buộc ứng viên phải có kinh nghiệm thực tế, nhưng cần đáp ứng các yêu cầu sau:",
        items: [
          "Có niềm yêu thích và mong muốn học hỏi về Artificial Intelligence.",
          "Có kỹ năng Công nghệ phần mềm, làm việc nhóm.",
          "Có trách nhiệm với task được giao.",
          "Sẵn sàng tham gia các hoạt động và dự án của GDG On Campus – DUT.",
          "Chủ động trong công việc, có tinh thần trách nhiệm và kỷ luật.",
          "Tư duy logic, khả năng tự học và research tìm kiếm tài liệu.",
          "Làm việc nhóm, giao tiếp tốt, sẵn sàng nhận feedback và có khả năng trình bày technical concept.",
          "Không ngại thử nghiệm và thất bại, nhanh nhạy với xu hướng công nghệ mới.",
        ],
      },
      evaluation: {
        groups: [
          {
            title: "Mục tiêu chuyên môn đầu ra",
            items: [
              "Mức độ nắm vững kiến thức được đào tạo.",
              "Khả năng áp dụng kiến thức vào bài tập và sản phẩm.",
              "Khả năng giải thích mã nguồn do bản thân thực hiện.",
              "Mức độ tiến bộ trong nhiệm kỳ.",
            ],
          },
          {
            title: "Kết quả công việc",
            items: [
              "Mức độ hoàn thành bài tập và nhiệm vụ.",
              "Chất lượng sản phẩm.",
              "Khả năng đáp ứng yêu cầu và thời hạn.",
              "Mức độ chủ động trong việc tìm và sửa lỗi.",
            ],
          },
          {
            title: "Làm việc nhóm",
            items: [
              "Khả năng giao tiếp và phối hợp.",
              "Việc sử dụng Git và GitHub.",
              "Khả năng tiếp nhận phản hồi.",
              "Tinh thần hỗ trợ thành viên khác.",
              "Ý thức bảo vệ và tôn trọng sản phẩm chung.",
            ],
          },
          {
            title: "Thái độ và trách nhiệm",
            items: [
              "Mức độ tham gia hoạt động.",
              "Tính chủ động và kỷ luật.",
              "Tinh thần tự học.",
              "Trách nhiệm với nhiệm vụ được giao.",
              "Sự nghiêm túc và cam kết đồng hành cùng phòng ban.",
            ],
          },
        ],
      },
      benefits: {
        items: [
          "Được cấp giấy chứng nhận từ Google Developer.",
          "Trải nghiệm và làm việc trong các dự án công nghệ thực tế. Nâng cao và phát triển kỹ năng, kiến thức chuyên môn và các kỹ năng liên quan trong quá trình hoạt động.",
          "Có cơ hội được trao quyền và thử sức ở những vai trò mới. Có cơ hội tiếp cận với các công nghệ mới của Google.",
          "Trải nghiệm hợp tác cùng các công ty, tập đoàn công nghệ đa quốc gia.",
          "Gặp gỡ, giao lưu và chia sẻ với các anh chị có kinh nghiệm trong hệ sinh thái Google Developers.",
          "Mở rộng mối quan hệ, kết nối với cộng đồng những người đam mê công nghệ đến từ nhiều lĩnh vực khác nhau.",
        ],
      },
      closingNote:
        "Cảm ơn bạn đã quan tâm và đọc đến cuối bản mô tả công việc này. Chúng mình rất mong sớm được chào đón bạn trở thành một mảnh ghép của team trong thời gian tới!",
    },
  },
  {
    id: "software",
    name: "Software Department",
    title: "Software Engineer",
    badge: "SYSTEMS & FULL-STACK",
    docId: "1MJZ_xAutSqEcccrRMB2L-UL6zhyH_Fi1CKdqpiZUxG0",
    jdUrl:
      "https://docs.google.com/document/d/1MJZ_xAutSqEcccrRMB2L-UL6zhyH_Fi1CKdqpiZUxG0/edit?usp=drive_link",
    previewUrl:
      "https://docs.google.com/document/d/1MJZ_xAutSqEcccrRMB2L-UL6zhyH_Fi1CKdqpiZUxG0/preview",
    description:
      "Hợp nhất từ Frontend và Backend, phòng Software chịu trách nhiệm nghiên cứu, phát triển và duy trì các sản phẩm phần mềm phục vụ hoạt động của câu lạc bộ theo lộ trình Full-stack cơ bản.",
    focusItems: [
      "Quy trình Full-stack: Frontend, Backend, API & Database",
      "Xây dựng và phát triển các sản phẩm phần mềm thực tế của CLB",
      "Thực hành Git, GitHub collaborative workflows & Code review",
      "Nghiên cứu công nghệ mới và ứng dụng AI cơ bản trong phát triển",
    ],
    details: {
      overview: [
        "Phòng Software được hình thành trên cơ sở hợp nhất hai phòng ban Frontend và Backend. Phòng chịu trách nhiệm nghiên cứu, phát triển và duy trì các sản phẩm phần mềm phục vụ hoạt động của câu lạc bộ.",
        "Thành viên mới sẽ được định hướng phát triển theo lộ trình Full-stack cơ bản, từng bước tìm hiểu toàn bộ quy trình xây dựng sản phẩm, từ thiết kế giao diện, xử lý nghiệp vụ, kết nối API đến lưu trữ dữ liệu.",
      ],
      targetAudience: {
        items: [
          "Sinh viên của các trường Đại học/ Cao đẳng trên địa bàn Thành phố Đà Nẵng.",
          "Ứng viên chưa có nhiều kinh nghiệm lập trình và chưa từng tham gia hoặc chưa hoàn thành một dự án phần mềm thực tế.",
          "Ứng viên mong muốn tìm hiểu về Frontend, Backend hoặc Full-stack.",
          "Ứng viên đam mê công nghệ, tinh thần học hỏi cao.",
        ],
      },
      responsibilities: {
        items: [
          "Tham gia đầy đủ các buổi đào tạo và hoạt động chuyên môn của phòng.",
          "Hoàn thành nhiệm vụ và sản phẩm theo từng giai đoạn.",
          "Tích cực tham gia phát triển các dự án nội bộ hoặc dự án thực tế của câu lạc bộ.",
          "Phối hợp với các thành viên ban khác trong quá trình xây dựng sản phẩm.",
          "Báo cáo tiến độ và những khó khăn gặp phải trong quá trình thực hiện nhiệm vụ.",
          "Chủ động nghiên cứu kiến thức, công nghệ và công cụ mới.",
          "Tuân thủ quy trình làm việc, thời hạn và quy ước chung của dự án.",
        ],
      },
      requirements: {
        lead: "Không bắt buộc ứng viên phải có kinh nghiệm thực tế, nhưng cần đáp ứng các yêu cầu sau:",
        items: [
          "Luôn mang tinh thần cầu tiến, chủ động hỏi leader hoặc những thành viên trong CLB trong những lúc gặp khó khăn.",
          "Có hứng thú với lập trình và phát triển sản phẩm phần mềm.",
          "Có tư duy logic và khả năng giải quyết vấn đề ở mức cơ bản.",
          "Có trách nhiệm với nhiệm vụ được giao.",
          "Có khả năng tự học và tìm kiếm tài liệu.",
          "Sẵn sàng làm việc nhóm và hỗ trợ các thành viên khác.",
          "Cam kết tham gia đầy đủ các buổi đào tạo, hoạt động và dự án của phòng ban.",
          "Có khả năng sắp xếp thời gian để hoàn thành nhiệm vụ đúng thời hạn.",
        ],
        advantages: {
          lead: "Ứng viên sẽ có lợi thế nếu đáp ứng những yêu cầu sau:",
          items: [
            "Biết căn bản về HTML, CSS, JavaScript.",
            "Biết một số ngôn ngữ lập trình, biết 1 hoặc nhiều framework.",
            "Cách Frontend làm việc với Backend thông qua API.",
            "Biết sử dụng Git, Github để quản lý công việc.",
            "Có kinh nghiệm làm đồ án, nghiên cứu khoa học ở trên trường hoặc xây dựng một dự án.",
            "Biết cách sử dụng AI cơ bản trong việc phát triển sản phẩm.",
          ],
        },
      },
      evaluation: {
        groups: [
          {
            title: "Mục tiêu chuyên môn đầu ra",
            items: [
              "Mức độ nắm vững kiến thức được đào tạo.",
              "Khả năng áp dụng kiến thức vào bài tập và sản phẩm.",
              "Khả năng giải thích mã nguồn do bản thân thực hiện.",
              "Mức độ tiến bộ trong nhiệm kỳ.",
            ],
          },
          {
            title: "Kết quả công việc",
            items: [
              "Mức độ hoàn thành bài tập và nhiệm vụ.",
              "Chất lượng sản phẩm.",
              "Khả năng đáp ứng yêu cầu và thời hạn.",
              "Mức độ chủ động trong việc tìm và sửa lỗi.",
            ],
          },
          {
            title: "Làm việc nhóm",
            items: [
              "Khả năng giao tiếp và phối hợp.",
              "Việc sử dụng Git và GitHub.",
              "Khả năng tiếp nhận phản hồi.",
              "Tinh thần hỗ trợ thành viên khác.",
              "Ý thức bảo vệ và tôn trọng sản phẩm chung.",
            ],
          },
          {
            title: "Thái độ và trách nhiệm",
            items: [
              "Mức độ tham gia hoạt động.",
              "Tính chủ động và kỷ luật.",
              "Tinh thần tự học.",
              "Trách nhiệm với nhiệm vụ được giao.",
              "Sự nghiêm túc và cam kết đồng hành cùng phòng ban.",
            ],
          },
        ],
      },
      benefits: {
        items: [
          "Được cấp giấy chứng nhận từ Google Developer.",
          "Trải nghiệm và làm việc trong các dự án công nghệ thực tế. Nâng cao và phát triển kỹ năng, kiến thức chuyên môn và các kỹ năng liên quan trong quá trình hoạt động.",
          "Có cơ hội được trao quyền và thử sức ở những vai trò mới. Có cơ hội tiếp cận với các công nghệ mới của Google.",
          "Trải nghiệm hợp tác cùng các công ty, tập đoàn công nghệ đa quốc gia.",
          "Gặp gỡ, giao lưu và chia sẻ với các anh chị có kinh nghiệm trong hệ sinh thái Google Developers.",
          "Mở rộng mối quan hệ, kết nối với cộng đồng những người đam mê công nghệ đến từ nhiều lĩnh vực khác nhau.",
        ],
      },
      closingNote:
        "Cảm ơn bạn đã quan tâm và đọc đến cuối bản mô tả công việc này. Chúng mình rất mong sớm được chào đón bạn trở thành một mảnh ghép của team trong thời gian tới!",
    },
  },
  {
    id: "marketing",
    name: "Marketing Department",
    title: "Marketing Specialist",
    badge: "CREATIVE & MEDIA",
    docId: "1K9ZLINhIT4xaQXyK1uP2RO-Pc-lSOlDa-mOkx6mpyFk",
    jdUrl:
      "https://docs.google.com/document/d/1K9ZLINhIT4xaQXyK1uP2RO-Pc-lSOlDa-mOkx6mpyFk/edit?usp=drive_link",
    previewUrl:
      "https://docs.google.com/document/d/1K9ZLINhIT4xaQXyK1uP2RO-Pc-lSOlDa-mOkx6mpyFk/preview",
    description:
      "Phòng Marketing [Public relation] tập trung vào các mảng UI/UX design, Content Marketing, Media và AI in Marketing, xây dựng hình ảnh và truyền tải nội dung giá trị cho CLB.",
    focusItems: [
      "UI/UX design, Content Marketing, Media & AI in Marketing",
      "Sáng tạo nội dung, thiết kế ấn phẩm & sản xuất video",
      "Xây dựng hình ảnh và nhận diện thương hiệu GDGoC DUT",
      "Phân tích số liệu trên nền tảng để tối ưu hóa chiến dịch truyền thông",
    ],
    details: {
      overview: [
        "Phòng Marketing [Public relation] là bộ phận chuyên môn tập trung vào các mảng UI/UX design, Content Marketing, Media và AI in Marketing. Phòng chịu trách nhiệm nghiên cứu xu hướng, xây dựng hình ảnh, truyền tải nội dung nhằm mang lại giá trị thực tiễn phục vụ hoạt động của câu lạc bộ.",
        "Thành viên mới sẽ được định hướng phát triển theo lộ trình chuyên môn về sáng tạo nội dung, thiết kế truyền thông và sản xuất media, từng bước tìm hiểu toàn bộ vòng đời phát triển dự án truyền thông. Lộ trình này trải dài từ khâu lên ý tưởng, nghiên cứu xu hướng, thiết kế ấn phẩm, quay/dựng video, cho đến việc phân tích số liệu trên nền tảng để tối ưu hóa chiến dịch.",
      ],
      targetAudience: {
        lead: "Chúng tôi tìm kiếm những ứng viên phù hợp với các tiêu chí sau:",
        items: [
          "Sinh viên của các trường trên địa bàn Thành phố Đà Nẵng.",
          "Ứng viên có mong muốn tìm kiếm môi trường thực hành để sáng tạo nội dung, thiết kế ấn phẩm và sản xuất Media.",
          "Ứng viên chưa từng tham gia hoặc chưa hoàn thành một chiến dịch truyền thông thực tế.",
          "Ứng viên tìm hiểu và phát triển chuyên môn về content, thiết kế và truyền thông.",
          "Sinh viên có tư duy sáng tạo (bố cục, màu sắc), nhạy bén với xu hướng và đam mê ứng dụng các công cụ AI vào Marketing thực tế.",
        ],
      },
      responsibilities: {
        lead: "Dựa trên vai trò đảm nhận, thành viên sẽ thực hiện các nhiệm vụ chuyên môn sau:",
        items: [
          "Sử dụng được các tool AI marketing.",
          "Chụp/quay các sự kiện và các buổi sinh hoạt của GDSC - DUT (những buổi chính - nếu có máy ảnh).",
          "Thực hiện, biên tập các sản phẩm video, hình ảnh.",
          "Thiết kế ấn phẩm truyền thông.",
          "Lập kế hoạch và xây dựng nội dung trên các kênh truyền thông.",
          "Nghiên cứu, nắm bắt xu hướng và sáng tạo nội dung cho các kênh và các sự kiện.",
          "Tham gia hỗ trợ phòng ban khác trong các hoạt động của GDSC - DUT.",
        ],
      },
      requirements: {
        lead: "Không bắt buộc ứng viên phải có kinh nghiệm thực tế, nhưng cần đáp ứng các yêu cầu sau:",
        items: [
          "Luôn mang tinh thần cầu tiến, chủ động hỏi leader hoặc những thành viên trong CLB trong những lúc gặp khó khăn.",
          "Có tư duy logic, sáng tạo và khả năng giải quyết vấn đề ở mức cơ bản.",
          "Có trách nhiệm với nhiệm vụ được giao.",
          "Có khả năng tự học và tìm kiếm tài liệu.",
          "Sẵn sàng làm việc nhóm và hỗ trợ các thành viên khác.",
          "Cam kết tham gia đầy đủ các buổi đào tạo, hoạt động và dự án của phòng ban.",
          "Có khả năng sắp xếp thời gian để hoàn thành nhiệm vụ đúng thời hạn.",
          "Làm việc nhóm, giao tiếp tốt, sẵn sàng nhận feedback và có khả năng trình bày concept/theme/ ý tưởng truyền thông.",
        ],
        advantages: {
          lead: "Ứng viên sẽ có lợi thế lớn nếu đáp ứng những yêu cầu sau:",
          categories: [
            {
              title: "Media",
              items: [
                "Có hiểu biết cơ bản về chụp ảnh, quay dựng video.",
                "Có khả năng chỉnh sửa video bằng các phần mềm.",
                "Có máy ảnh là một lợi thế.",
              ],
            },
            {
              title: "Designer",
              items: [
                "Khả năng thiết kế ấn phẩm truyền thông.",
                "Hiểu biết cơ bản các công cụ, phần mềm thiết kế.",
                "Có tư duy sáng tạo (bố cục, màu sắc,...).",
              ],
            },
            {
              title: "Content",
              items: [
                "Lập kế hoạch và xây dựng nội dung trên các kênh truyền thông.",
                "Nghiên cứu, nắm bắt xu hướng và sáng tạo nội dung cho các kênh và các sự kiện.",
                "Phân tích số liệu nội dung trên các nền tảng để nắm bắt các vấn đề và triển khai các giải pháp.",
              ],
            },
          ],
        },
      },
      evaluation: {
        groups: [
          {
            title: "Mục tiêu chuyên môn đầu ra",
            items: [
              "Mức độ nắm vững kiến thức được đào tạo.",
              "Khả năng áp dụng kiến thức vào bài tập và sản phẩm.",
              "Khả năng giải thích các concept/theme/ ý tưởng truyền thông do bản thân thực hiện.",
              "Mức độ tiến bộ trong nhiệm kỳ.",
            ],
          },
          {
            title: "Kết quả công việc",
            items: [
              "Mức độ hoàn thành bài tập và nhiệm vụ.",
              "Chất lượng sản phẩm, chất lượng quy trình.",
              "Khả năng đáp ứng yêu cầu và thời hạn.",
              "Mức độ chủ động trong việc tìm và sửa lỗi.",
            ],
          },
          {
            title: "Làm việc nhóm & Công cụ",
            items: [
              "Khả năng giao tiếp và phối hợp.",
              "Khả năng tiếp nhận phản hồi.",
              "Tinh thần hỗ trợ thành viên khác.",
              "Ý thức bảo vệ và tôn trọng sản phẩm chung.",
              "Làm việc cùng các công cụ Marketing.",
            ],
          },
          {
            title: "Thái độ và trách nhiệm",
            items: [
              "Mức độ tham gia hoạt động.",
              "Tính chủ động và kỷ luật.",
              "Tinh thần tự học.",
              "Trách nhiệm với nhiệm vụ được giao.",
              "Sự nghiêm túc và cam kết đồng hành cùng phòng ban.",
            ],
          },
        ],
      },
      benefits: {
        items: [
          "Được cấp giấy chứng nhận từ Google Developer.",
          "Trải nghiệm và làm việc trong các dự án công nghệ thực tế. Nâng cao và phát triển kỹ năng, kiến thức chuyên môn và các kỹ năng liên quan trong quá trình hoạt động.",
          "Có cơ hội được trao quyền và thử sức ở những vai trò mới. Có cơ hội tiếp cận với các công nghệ mới của Google.",
          "Trải nghiệm hợp tác cùng các công ty, tập đoàn công nghệ đa quốc gia.",
          "Gặp gỡ, giao lưu và chia sẻ với các anh chị có kinh nghiệm trong hệ sinh thái Google Developers.",
          "Mở rộng mối quan hệ, kết nối với cộng đồng những người đam mê công nghệ đến từ nhiều lĩnh vực khác nhau.",
        ],
      },
      closingNote:
        "Cảm ơn bạn đã quan tâm và đọc đến cuối bản mô tả công việc này. Chúng mình rất mong sớm được chào đón bạn trở thành một mảnh ghép của team trong thời gian tới!",
    },
  },
  {
    id: "bizdev",
    name: "Business Development Department",
    title: "Business Development Associate",
    badge: "PRODUCT & BUSINESS ANALYSIS",
    docId: "1NYOAxyRFYkYCE_cn8UFKiXG2cNeA81QUe3uuGoJuh9w",
    jdUrl:
      "https://docs.google.com/document/d/1NYOAxyRFYkYCE_cn8UFKiXG2cNeA81QUe3uuGoJuh9w/edit?usp=drive_link",
    previewUrl:
      "https://docs.google.com/document/d/1NYOAxyRFYkYCE_cn8UFKiXG2cNeA81QUe3uuGoJuh9w/preview",
    description:
      "Bộ phận Non-Tech chịu trách nhiệm phân tích yêu cầu, xử lý dữ liệu, định hướng phát triển sản phẩm và quản lý dự án nhằm đảm bảo giải pháp công nghệ đáp ứng đúng mục tiêu nghiệp vụ.",
    focusItems: [
      "Phân tích yêu cầu nghiệp vụ (BRD, SRS) & Mô hình hóa quy trình",
      "Công cụ phân tích dữ liệu (SQL, Python, Tableau, Power BI)",
      "Quản lý dự án & giám sát tiến độ (Agile, Scrum, JIRA, ClickUp)",
      "Định hướng phát triển sản phẩm công nghệ và giải quyết bài toán thực tế",
    ],
    details: {
      overview: [
        "Phòng Business Development là bộ phận chuyên môn trực thuộc Non-Tech Team của câu lạc bộ GDG On Campus – DUT. Phòng chịu trách nhiệm phân tích yêu cầu, xử lý dữ liệu, định hướng phát triển sản phẩm và quản lý dự án, nhằm đảm bảo các giải pháp công nghệ đáp ứng đúng mục tiêu nghiệp vụ và mang lại giá trị thực tiễn phục vụ hoạt động của câu lạc bộ.",
        "Thành viên mới sẽ được định hướng phát triển theo lộ trình chuyên môn về phân tích nghiệp vụ và quản lý sản phẩm, từng bước tìm hiểu toàn bộ vòng đời phát triển dự án. Lộ trình này trải dài từ khâu đặc tả yêu cầu kinh doanh, mô hình hóa quy trình, phân tích dữ liệu, cho đến việc phối hợp liên phòng ban để giám sát tiến độ, triển khai và tối ưu hóa các giải pháp.",
      ],
      targetAudience: {
        lead: "Chúng tôi tìm kiếm những ứng viên phù hợp với các tiêu chí sau:",
        items: [
          "Sinh viên của các trường trên địa bàn Thành phố Đà Nẵng.",
          "Ứng viên có mong muốn tìm kiếm môi trường thực hành để phân tích yêu cầu, xử lý dữ liệu và quản lý vòng đời dự án phần mềm.",
          "Ứng viên chưa từng tham gia hoặc chưa hoàn thành một dự án phần mềm thực tế.",
          "Ứng viên tìm hiểu và phát triển chuyên môn về phân tích nghiệp vụ, trực quan hóa dữ liệu và phát triển sản phẩm công nghệ.",
          "Sinh viên có tư duy nhạy bén với công nghệ (tech-oriented) và đam mê ứng dụng công nghệ hoặc tool vào giải quyết các bài toán thực tế.",
        ],
      },
      responsibilities: {
        lead: "Dựa trên vai trò đảm nhận, thành viên sẽ thực hiện các nhiệm vụ chuyên môn sau:",
        items: [
          "Ứng viên có mong muốn tìm kiếm môi trường thực hành để phân tích yêu cầu, xử lý dữ liệu và quản lý dự án công nghệ.",
          "Ứng viên tìm hiểu và phát triển về tài liệu hóa kỹ thuật (BRD, SRS), công cụ phân tích (SQL, Python, Tableau) và quy trình phát triển sản phẩm.",
          "Quản lý dự án và giám sát tiến độ, phối hợp với các bộ phận kỹ thuật, marketing cùng các role dự án để đảm bảo dự án đạt được mục tiêu. Giải quyết các vấn đề phát sinh trong quá trình triển khai.",
          "Sinh viên có đam mê kết hợp giữa kinh doanh và lĩnh vực công nghệ.",
        ],
      },
      requirements: {
        lead: "Không bắt buộc ứng viên phải có kinh nghiệm thực tế, nhưng cần đáp ứng các yêu cầu sau:",
        items: [
          "Luôn mang tinh thần cầu tiến, chủ động hỏi leader hoặc những thành viên trong CLB trong những lúc gặp khó khăn.",
          "Có hứng thú với kinh tế, tài chính, kinh doanh, kế toán… và xây dựng tài liệu kỹ thuật.",
          "Có tư duy logic và khả năng giải quyết vấn đề ở mức cơ bản.",
          "Có trách nhiệm với nhiệm vụ được giao.",
          "Có khả năng tự học và tìm kiếm tài liệu.",
          "Sẵn sàng làm việc nhóm và hỗ trợ các thành viên khác.",
          "Cam kết tham gia đầy đủ các buổi đào tạo, hoạt động và dự án của phòng ban.",
          "Có khả năng sắp xếp thời gian để hoàn thành nhiệm vụ đúng thời hạn.",
          "Làm việc nhóm, giao tiếp tốt, sẵn sàng nhận feedback và có khả năng trình bày business analysis concept.",
        ],
        advantages: {
          lead: "Ứng viên sẽ có lợi thế lớn nếu đáp ứng những yêu cầu sau:",
          items: [
            "Hiểu biết về các phương pháp phát triển phần mềm (Agile, Scrum, Waterfall) và tài chính cơ bản.",
            "Biết sử dụng SQL để truy vấn và phân tích dữ liệu.",
            "Biết cách mô hình hóa quy trình (BPMN, Visio, Draw.io) và trực quan hóa dữ liệu (Tableau, Power BI).",
            "Biết sử dụng các phần mềm quản lý dự án (JIRA, Clickup, Confluence).",
            "Có khả năng thu thập, phân tích, theo dõi yêu cầu dự án và diễn giải số liệu thống kê.",
          ],
        },
      },
      evaluation: {
        groups: [
          {
            title: "Mục tiêu chuyên môn đầu ra",
            items: [
              "Mức độ nắm vững kiến thức được đào tạo.",
              "Khả năng áp dụng kiến thức vào bài tập và sản phẩm.",
              "Khả năng giải thích các case business do bản thân thực hiện.",
              "Mức độ tiến bộ trong nhiệm kỳ.",
            ],
          },
          {
            title: "Kết quả công việc",
            items: [
              "Mức độ hoàn thành bài tập và nhiệm vụ.",
              "Chất lượng sản phẩm, chất lượng quy trình.",
              "Khả năng đáp ứng yêu cầu và thời hạn.",
              "Mức độ chủ động trong việc tìm và sửa lỗi.",
            ],
          },
          {
            title: "Làm việc nhóm & Công cụ",
            items: [
              "Khả năng giao tiếp và phối hợp.",
              "Khả năng tiếp nhận phản hồi.",
              "Tinh thần hỗ trợ thành viên khác.",
              "Ý thức bảo vệ và tôn trọng sản phẩm chung.",
              "Làm việc cùng các công cụ Business.",
            ],
          },
          {
            title: "Thái độ và trách nhiệm",
            items: [
              "Mức độ tham gia hoạt động.",
              "Tính chủ động và kỷ luật.",
              "Tinh thần tự học.",
              "Trách nhiệm với nhiệm vụ được giao.",
              "Sự nghiêm túc và cam kết đồng hành cùng phòng ban.",
            ],
          },
        ],
      },
      benefits: {
        items: [
          "Được cấp giấy chứng nhận từ Google Developer.",
          "Trải nghiệm và làm việc trong các dự án công nghệ thực tế. Nâng cao và phát triển kỹ năng, kiến thức chuyên môn và các kỹ năng liên quan trong quá trình hoạt động.",
          "Có cơ hội được trao quyền và thử sức ở những vai trò mới. Có cơ hội tiếp cận với các công nghệ mới của Google.",
          "Trải nghiệm hợp tác cùng các công ty, tập đoàn công nghệ đa quốc gia.",
          "Gặp gỡ, giao lưu và chia sẻ với các anh chị có kinh nghiệm trong hệ sinh thái Google Developers.",
          "Mở rộng mối quan hệ, kết nối với cộng đồng những người đam mê công nghệ đến từ nhiều lĩnh vực khác nhau.",
        ],
      },
      closingNote:
        "Cảm ơn bạn đã quan tâm và đọc đến cuối bản mô tả công việc này. Chúng mình rất mong sớm được chào đón bạn trở thành một mảnh ghép của team trong thời gian tới!",
    },
  },
];

export const BENEFITS = [
  {
    number: "01",
    title: "Google Developer Certificate",
    description:
      "Được cấp giấy chứng nhận chính thức từ Google Developer khi hoàn thành nhiệm kỳ hoạt động tích cực.",
  },
  {
    number: "02",
    title: "Real-World Experience",
    description:
      "Trực tiếp tham gia phát triển các dự án công nghệ thực tế, tiếp cận sớm với các công nghệ và tài nguyên mới nhất của Google.",
  },
  {
    number: "03",
    title: "Industry Network",
    description:
      "Mở rộng mối quan hệ với các anh chị chuyên gia kỳ cựu trong hệ sinh thái Google Developers và các tập đoàn công nghệ lớn.",
  },
  {
    number: "04",
    title: "Empowerment & Culture",
    description:
      "Được trao quyền thử sức ở các vị trí dẫn dắt, phát triển kỹ năng lãnh đạo trong môi trường 'By community, for community'.",
  },
];
